import axiosInstance from "../../../helpers/api";

export const getAllPDFs = (body) => {
  return axiosInstance.get("/superadmin/pdfs", body);
};

export const editPDFs = (formData) => {
  return axiosInstance.post(
    `/superadmin/pdfs/${formData.id}`,
    formData.formData
  );
};

export const createPDFs = (formData) => {
  return axiosInstance.post("/superadmin/pdfs", formData);
};

export const deletePDF = (id) => {
  return axiosInstance.delete(`/superadmin/pdfs/${id}`);
};

export const getCoursePDF = (id) => {
  return axiosInstance.get(`/superadmin/pdfs/course/${id}`);
};
